/*
 * Parsec
 * https://github.com/d-plaindoux/parsec
 *
 * Copyright (c) 2016 Didier Plaindoux
 * Licensed under the LGPL2 license.
 */

import F from './parsec/flow-bundle';
import C from './parsec/chars-bundle';
import N from './parsec/numbers-bundle';

export default {
    F,
    C,
    N,
};
